var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"inputText"},[_c('div',{staticClass:"labelForm"},[_vm._v(_vm._s(_vm.item.label || 'Testo Label'))]),_c('hr')])}
var staticRenderFns = []

export { render, staticRenderFns }